<template>
	<div>
		<ts-card-wrapper class="ts-space-y-2">
			<div class="ts-w-full ts-justify-between ts-flex">
				<div>
					<h1 class="section-divider-underline">
						{{ $t('paymentToVendor.invoice') }}
					</h1>
				</div>
			</div>
			<div style="max-height: 70vh; height: 70vh">
				<a-table :scroll="{ y: 555 }" size="small" :pagination="false" :columns="columns"
					:row-key="payment_list => payment_list.stock_in_id" :data-source="model.payment_list"
					:row-selection="{ onChange: checkItem }" :loading="loading">
					<template slot="amount_due" slot-scope="record">
						{{ displayCurrency(record) }}
					</template>
					<template slot="amount_due_paid" slot-scope="record">
						{{ displayCurrencyAmountDuePaid(record) }}
					</template>
					<template slot="amount_paid" slot-scope="record">
						{{ record ? displayCurrency(record) : '$ 0.00' }}
					</template>
					<template slot="footer" slot-scope="record">
						<div class="ts-flex ts-justify-between ts--mx-1">
							<div>Total: {{ checkedInvoice.length }}/{{ record.length }}</div>
							<div class="ts-flex">
								<div class="ts-w-40 ts-text-right">
									{{ totalInvoiceAmount(record) }}
								</div>
								<div class="ts-w-40 ts-text-right">
									{{ totalAmountDue(record) }}
								</div>
								<div class="ts-w-40 ts-text-right">
									{{ totalAmountPaid(record) }}
								</div>
							</div>
						</div>
					</template>
				</a-table>
			</div>
		</ts-card-wrapper>
	</div>
</template>
  
<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'

export default {
	name: 'invoice-detail',
	props: ['value', 'validation'],
	data() {
		return {
			loading: false,
			search: '',
			model: {},
			errors: new Errors(),
			checkedInvoice: []
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		columns() {
			return [
				{
					title: this.$t('paymentToVendor.date'),
					dataIndex: 'stock_in_date'
				},
				{
					title: this.$t('paymentToVendor.pcInvoice'),
					dataIndex: 'stock_in_number',
					width: '160px'
				},
				{
					title: this.$t('paymentToVendor.referenceNo'),
					dataIndex: 'invoice_no'
				},
				{
					title: this.$t('paymentToVendor.nextPayment'),
					dataIndex: 'next_payment_date'
				},
				{
					title: this.$t('paymentToVendor.billAmount'),
					dataIndex: 'invoice_amount',
					scopedSlots: { customRender: 'invoice_amount' },
					className: 'text-right'
				},
				{
					title: this.$t('paymentToVendor.amountDue'),
					scopedSlots: { customRender: 'amount_due_paid' },
					className: 'text-right'
				},
				{
					title: this.$t('paymentToVendor.amountPaid'),
					dataIndex: 'amount_paid',
					scopedSlots: { customRender: 'amount_paid' },
					className: 'text-right'
				}
			]
		}
	},
	methods: {
		displayCurrency(record) {
			if (parseInt(record)) {
				return this.$currencyFormat(_.round(record, 2))
			}
			return '$ ' + parseFloat(record).toFixed(2)
		},
		totalInvoiceAmount(records) {
			let totalInvoiceAmount = _.sumBy(records, function (el) {
				return parseFloat(el.invoice_amount)
			})
			if (parseInt(totalInvoiceAmount)) {
				return this.$currencyFormat(_.round(totalInvoiceAmount, 2))
			}
			return 0
		},

		totalAmountDue(records) {
			let totalAmountDue = _.sumBy(records, function (el) {
				return parseFloat(el.amount_due_paid)
			})
			if (parseInt(totalAmountDue)) {
				return this.$currencyFormat(_.round(totalAmountDue, 2))
			}
			return 0
		},

		totalAmountPaid(records) {
			let totalAmountPaid = _.sumBy(records, function (el) {
				return parseFloat(el.amount_paid)
			})
			if (parseInt(totalAmountPaid)) {
				return this.$currencyFormat(_.round(totalAmountPaid, 2))
			}
			return 0
		},

		displayCurrencyAmountDuePaid(record) {
			if (
				_.round(record.amount_due_paid) ||
				_.round(record.amount_due) == _.round(record.amount_paid)
			) {
				if (_.round(record.amount_due_paid)) {
					return this.$currencyFormat(_.round(record.amount_due_paid, 2))
				}
				return '$ ' + _.round(record.amount_due_paid, 2)
			}
			return this.$currencyFormat(_.round(record.amount_due, 2))
		},
		checkItem(value) {
			this.checkedInvoice = []
			if (!_.isEmpty(value)) {
				value.forEach(element => {
					this.checkedInvoice.push(element)
				})
			}
			this.calculationAmountPaid()
		},
		calculationAmountPaid() {
			let oldAmountPaid = this.model.amount_paid
			let invoiceListsCheck = this.model.payment_list
			this.model.payment_list = []
			this.model.invoice_amount = null

			invoiceListsCheck.forEach(e => {
				let amount_paid = 0
				let amount_due = 0
				let is_check_item = e.is_check
				let check = this.checkedInvoice.find(el => el == e.stock_in_id)
				if (check) {
					this.model.invoice_amount = parseFloat(
						this.model.invoice_amount + e.amount_due
					)
					let param = this.model.amount_paid - e.amount_due
					if (param > 0) {
						amount_paid = e.amount_due
						amount_due = 0
						this.model.amount_paid = param
					} else {
						if (this.model.amount_paid > 0) {
							amount_paid = this.model.amount_paid
							amount_due = e.amount_due - this.model.amount_paid
							this.model.amount_paid = 0
						} else {
							amount_paid = 0
							amount_due = e.amount_due
						}
					}
					is_check_item = true
				} else {
					is_check_item = false
				}
				this.model.payment_list.push({
					amount_due: e.amount_due,
					stock_in_id: e.stock_in_id,
					ref_number: e.amount_due,
					bill_amount: e.amount_due,
					discount_rate: 0,
					discount_type: '%',
					discount_amount: 0,
					next_payment_date: e.next_payment_date,
					stock_in_date: e.stock_in_date,
					invoice_no: e.invoice_no,
					invoice_amount: e.invoice_amount,
					stock_in_number: e.stock_in_number,
					amount_paid: _.round(amount_paid, 4),
					amount_due_paid: _.round(amount_due, 4),
					is_check: is_check_item
				})
			})
			this.model.amount_paid = oldAmountPaid

			this.model.amount_due = _.round(
				this.model.invoice_amount - this.model.amount_paid,
				2
			)
		},
		getPurchasInvoiceList() {
			if (this.model.vendor_id) {
				this.loading = true
				this.$store
					.dispatch('supplier/payment/getPurchasInvoice', this.model.vendor_id)
					.then(response => {
						this.model.payment_list = response.data.map(el => ({
							stock_in_date: el.stock_in_date,
							stock_in_number: el.stock_in_number,
							invoice_no: el.invoice_no,
							next_payment_date: el.next_payment_date,
							invoice_amount: el.invoice_amount,
							amount_due: el.amount_due,
							amount_paid: el.amount_paid,
							stock_in_id: el.stock_in_id,
							is_check: false
						}))
					})
					.catch(error => {
						this.$toasted.error(error.message)
						this.errors = new Errors(error.errors)
					})
					.finally(() => {
						this.loading = false
					})
			} else {
				this.model.payment_list = []
			}
		},
		getNextPaymentDate() {
			let check = this.model.payment_list.find(
				el => el.amount_due - el.amount_paid > 0
			)
			if (check) {
				this.model.next_payment_date = check.next_payment_date
			}
		}
	},
	watch: {
		'model.vendor_id': debounce(function () {
			this.getPurchasInvoiceList()
		}, 500),
		'model.payment_list': debounce(function () {
			this.getNextPaymentDate()
		}, 500),
		search: debounce(function (search) {
			this.handleSearch(search)
		}, 500)
	}
}
</script>
  
<style lang="css" scoped>
.section-divider-underline {
	padding-bottom: 5px;
	margin: 0 0 8px 0;
	font-size: 16px;
	color: #929090;
	font-weight: 400;
	text-transform: uppercase;
}

.text-right {
	text-align: right;
}

.no-wrap {
	white-space: nowrap;
}
</style>
  